// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Hfgl","col":"styles_col__3dKWS"};